//这里公开绘制对象的对外接口

import * as THREE from 'three';
import {
  CARD1Web,
  MouseAction
} from '@/drawings3D/CoordUtils.js';
import {NavControllCommand} from '../../components/Web3dModels/commands/NavControllCommand.js'
import {FlyNavControlCommand} from '../../components/Web3dModels/commands/FlyNavControlCommand.js'
import {BadDrawer} from '../../drawings3D/modelDrawing/BadDrawer.js'
import {DefectControlCommand} from '../../components/Web3dModels/commands/DefectControlCommand.js'
export class DrawApi{
	constructor(web3DView){
		this.web3DView = web3DView;	
	}
	// 查找工具
	getModelById(uuid){
       let meshes= this.web3DView.sceneManager.geometryManager.getTargetMeshes();
       let mesh=null
       meshes.forEach((item,index)=>{
       	  if(item.uuid==uuid){
       	  	  mesh=item
       	  }
       })
       return mesh;
	}

	getMeshGroup(){
		return this.web3DView.sceneManager.geometryManager.getMeshes();
	}
	// 模型显示轨迹
	showLocus(uuid,list){
	  // this.removePanel();
	  var nodes = [];
      list.forEach(item=>{
           let x = item.lat;
           let z = item.lon;
           nodes.push({
           	  x:x,
           	  z:z
           })
      })
      if(nodes.length==0){
      	  return
      }
	  this.web3DView.sceneManager.geometryManager.removeLocusMesh();
      let mesh= this.getModelById(uuid); 
      var objLoader = mesh.loader;
      if(mesh){
	      objLoader.showRoute({
	        id: 1,
	        nodes:nodes
	      });
	      // objLoader.animateRoute();
      }else{
      	 console.log('模型不存在')
      }
	}

    animateLocus(uuid,list){
       // this.removePanel();
      if(!this.oldSpeed){
          var nodes = [];
          list.forEach(item=>{
               let x = item.lat;
               let z = item.lon;
               nodes.push({
               	  x:x,
               	  z:z
               })
          })
          if(nodes.length==0){
          	  return
          }
          this.web3DView.sceneManager.geometryManager.removeLocusMesh();
          let mesh= this.getModelById(uuid); 
          var objLoader = mesh.loader;
          this.activeLocus = objLoader;
          if(mesh){
    	      objLoader.showRoute({
    	        id: 1,
    	        nodes: nodes
    	      });
    	      objLoader.animateRoute();
          }else{
          	 console.log('模型不存在')
          }
      }else{
          this.activeLocus.modelInfo.route.speed = this.oldSpeed;
          this.oldSpeed = null;
      }  
    }
	hasPanel(){
		var dom= this.web3DView.sceneManager.pointLabel;
	    if(dom){
	    	return true
	    }else{
	    	return false
	    }
	}
	
	showPanel(uuid,dom){
		 let mesh=this.getModelById(uuid);
         this.web3DView.sceneManager.geometryManager.showModelPanel(mesh,dom); 
	}

	removePanel(){
	   var dom= this.web3DView.sceneManager.pointLabel;
       this.web3DView.sceneManager.scene.remove(dom);
       this.web3DView.sceneManager.pointLabel=null;
       document.getElementById('WebGL-output').removeChild(this.web3DView.sceneManager.labelRenderer.domElement);
	}
    
    showInfoPanel(uuid,dom){
         let mesh=this.getModelById(uuid);
         var style=this.web3DView.sceneManager.geometryManager.showInfoPanel(mesh,dom);
         return style;
    }

    addInfoPanel(){
    	this.web3DView.sceneManager.geometryManager.addInfoPanel();
    }

    removeInfoPanel(){
         // document.getElementById('app').removeChild(this.web3DView.sceneManager.panelRenderer.domElement);
         var dom= this.web3DView.sceneManager.pointPanel;
         this.web3DView.sceneManager.scene.remove(dom);
         this.web3DView.sceneManager.pointPanel=null;
         this.web3DView.sceneManager.panelRenderer=null;
    }


	searchModel(data){
	   let meshes= this.web3DView.sceneManager.geometryManager.getMeshes();
       let mesh=null;
       var position=new THREE.Vector3();
       meshes.forEach((item,index)=>{
       	  if(item.oInfo&&item.oInfo.type==data.type&&item.oInfo.id==data.id){
       	  	  mesh=item
       	  }
       })
       if(mesh){
       	  var meshArr=[];
       	  meshArr.push(mesh);
       	  this.web3DView.sceneManager.outlinePassSearch.selectedObjects=meshArr;
          position.copy(mesh.position);
       }
       let pos=new THREE.Vector3();
       let lookAt=new THREE.Vector3();
       pos.copy(position);
       pos.setZ(pos.z-50);
       lookAt.copy(position);
       pos.y+=3;
       this.web3DView.sceneManager.camera.move(pos,position);   

	}

	searchModelById(uuid){
       let mesh=this.getModelById(uuid);
       var position=new THREE.Vector3();
       if(mesh){
       	  var meshArr=[];
       	  meshArr.push(mesh);
       	  this.web3DView.sceneManager.outlinePassSearch.selectedObjects=meshArr;
          position.copy(mesh.position);
       }
       let pos=new THREE.Vector3();
       let lookAt=new THREE.Vector3();
       pos.copy(position);
       pos.setZ(pos.z-50);
       lookAt.copy(position);
       pos.y+=3;
       this.web3DView.sceneManager.camera.move(pos,position); 
	}

	//在地图中显示sos图标
	showSosInMap(arr){
		this.web3DView.map.showSos(arr);
	}

	//初始化路面材料
	initRoadMaterails(materails){
		this.web3DView.sceneManager.getRoadManager().assignRoadMaterials(materails);
	}
   

   //控制渲染道路细节模型
	setRoadPartOption(option){
		this.web3DView.roadPartOption = new CARD1Web.CoordUtils.Helper().merge(this.web3DView.roadPartOption, option);	
	}
	    
	//模型驾驶相关操作
	// 开车
	carNav(num){
		if(num||num===0){
			var e = {'command': new NavControllCommand(num,this.web3DView)};
			e.command.exec.call(e.command, this.web3DView);
			if(num==2||num==3){
				this.web3DView.sendCarSpeed();
			}
		}
	}

	flyNav(num){
		if(num||num===0){
			var e = {'command': new FlyNavControlCommand(num,this.web3DView)};
			e.command.exec.call(e.command, this.web3DView);
			if(num==2||num==3){
				this.web3DView.sendFlySpeed();
			}
			if(num==4||num==5){
				this.web3DView.sendFlyHeight();
			}
		}
	}

	changeRoadFace(stakeArr){
		try{
			var road=this.web3DView.sceneManager.geometryManager.getMainRoad();
			stakeArr.forEach((item)=>{
				item.arr.forEach((oitem)=>{
					for(let i=oitem*10;i<=oitem*10+9;i++){
					   road.geometry.faces[i].materialIndex=parseInt(item.index);
					}
				})
			})
			// console.log('aaa',road.geometry)
			road.geometry.groupsNeedUpdate = true;
		}catch(e){
			this.web3DView.sendError();
		}
	}

	getTotalStake(){
		return this.web3DView.sceneManager.totalStake;
	}

	getNavAirMode(){
		return this.web3DView.sceneManager.roadNav.airMode;
	}

	drawBad(badInfo){
		var bad=new BadDrawer(badInfo.pos,badInfo.info,this.web3DView.sceneManager);
		bad.draw();
	}

	// clearModelCache(){
	// 	 var that=this;
 //         var meshObjs=this.web3DView.sceneManager.geometryManager.geometryContainer;
 //         if(meshObjs.length>0){
 //             for(var i=0;i<meshObjs.length;i++){
 //                 var curObj=meshObjs[i];
 //                 if(curObj.children.length>0){
 //                     var children=curObj.children;
 //                     for(var k=0;k<children.length;k++){
 //                     	this.deleteModel(children[k]);
 //                     } 
 //                 }else{
 //                 	 this.deleteModel(curObj);
 //                 }
 //             }
 //         }
	// }

	// deleteModel(group){
 //       if(!group){
 //       	  return
 //       }
 //       group.traverse(function(item){
 //           if(item instanceof THREE.Mesh){
 //           	  item.geometry.dispose(); // 删除几何体
 //              item.material.dispose(); // 删除材质
 //           }
 //       })
	// }

	removeModelGroup(name){
	   if((name=='person'||name=="equipment")){
	   	   this.web3DView.sceneManager.geometryManager.removeLocusMesh();
	   }
       let allmeshes = this.web3DView.sceneManager.geometryManager.getMeshes();
       allmeshes.forEach((item,index)=>{
       	    if(item.oInfo&&item.oInfo.largeClass==name){
       	    	this.web3DView.sceneManager.geometryManager.hideMoshes(item);
       	    }
       })
	}

	addModelGrop(name){
	   let meshes= this.web3DView.sceneManager.geometryManager.getMeshes();
       meshes.forEach((item)=>{
       	    if(item.oInfo&&item.oInfo.largeClass==name){
       	    	this.web3DView.sceneManager.scene.add(item);
       	    	this.web3DView.sceneManager.geometryManager.currentGeometryContainer.push(item);
       	    }
       })
	}

	test(uuid){
		let mesh=this.getModelById(uuid);
		return this.web3DView.sceneManager.geometryManager.getModelPanelPosition(mesh);
	}
    
    addDisease(data){
         var command = new DefectControlCommand(2, null, data.index,{type:'roadBad',largeClass:'roadSign',id:'',panel:true,badType:data.id,lv:data.lv,rightClick:data.rightClick});
         command.exec(this.web3DView);
    }
    addRoadSign(data){
    	 var command = new DefectControlCommand(4, null, null,{type:'标识牌',data:data});
         command.exec(this.web3DView);
    }
    closePanel(uuid){
    	let mesh=this.getModelById(uuid);
    	mesh.openPanel=false;
    	// this.web3DView.sceneManager.geometryManager.targetModel=null;
    }


    // 2020/2/9
    getLatLon(uuid){
       let mesh = this.getModelById(uuid);
       var lon = mesh.position.z+this.web3DView.sceneManager.CoordOffset.lon;
       var lat = mesh.position.x+this.web3DView.sceneManager.CoordOffset.lat; 
       return {
       	  lat:lat,
       	  lon:lon
       }
    }
    updateModelId(uuid,id){
       let mesh=this.getModelById(uuid);
       let oInfo = mesh.oInfo;
       oInfo.id = id;
       mesh.oInfo = oInfo;
    }

    // 2020/3/20
    accelerate(){
       if(!this.activeLocus){
            this.web3DView.sendMessage('warning','请先点击播放轨迹！');
            return
       }
       if(!this.oldSpeed){
           this.activeLocus.modelInfo.route.speed +=10;
           var message = "播放速度加10，当前速度为"+this.activeLocus.modelInfo.route.speed;
           this.web3DView.sendMessage('success',message);
       }else{
           this.oldSpeed+=10;
           var message = "播放速度加10，当前速度为"+this.oldSpeed;
           this.web3DView.sendMessage('success',message);
       }
  }
  decelerate(){
      if(!this.activeLocus){
           this.web3DView.sendMessage('warning','请先点击播放轨迹！');
           return
       }
       if(!this.oldSpeed){
           if(this.activeLocus.modelInfo.route.speed>=20){
              this.activeLocus.modelInfo.route.speed -=10;
              var message = "播放速度减10，当前速度为"+this.activeLocus.modelInfo.route.speed;
              this.web3DView.sendMessage('success',message);
           }else{
              this.web3DView.sendMessage('warning','播放速度不能低于10！');
              return
           }
       }else{
          if(this.oldSpeed>=20){
              this.oldSpeed-=10;
              var message = "播放速度减10，当前速度为"+this.oldSpeed;
              this.web3DView.sendMessage('success',message);
          }else{
              this.web3DView.sendMessage('warning','播放速度不能低于10！');
              return 
          }
       }
  }
  removeLocus(){
     this.oldSpeed = null;
     this.web3DView.sceneManager.geometryManager.removeLocusMesh();
  }
  pause(){
     this.oldSpeed = this.activeLocus.modelInfo.route.speed;
     this.activeLocus.modelInfo.route.speed = 0;
  }
  endAnimateLocus(){
     this.oldSpeed = null;
  }
  updateModelPosition(type,id,pos){
     let position = this.web3DView.sceneManager.geometryManager.helpModelPosition(pos.z,pos.x);
     let meshes= this.web3DView.sceneManager.geometryManager.getMeshes();
     meshes.forEach((item,index)=>{
        if(item.oInfo&&item.oInfo.type==type&&item.oInfo.id==id){
             item.position.copy(position); 
        }
     })
  }
  removeSosSate(id){
      let meshes= this.web3DView.sceneManager.geometryManager.getMeshes();
      meshes.forEach((item,index)=>{
        if(item.oInfo&&item.oInfo.type=='person'&&item.oInfo.id==id&&item.oInfo.notInteractive){
             this.web3DView.sceneManager.geometryManager.deleteModel(item);
        }
        if(item.oInfo&&item.oInfo.type=='person'&&item.oInfo.id==id&&!item.oInfo.notInteractive){
             item.oInfo.sos=false;
        }
     })
     if(this.web3DView.sceneManager.geometryManager.sosObjs instanceof Array){
         this.web3DView.sceneManager.geometryManager.sosObjs.forEach((item,index)=>{
             if(item.oInfo&&item.oInfo.type=='person'&&item.oInfo.id==id){
                  this.web3DView.sceneManager.geometryManager.sosObjs.splice(index,1);
             }
         })
     }     
  }
  addSosState(id){
      this.removeSosSate(id);
      let meshes= this.web3DView.sceneManager.geometryManager.getMeshes();
      meshes.forEach((item,index)=>{
          if(item.oInfo&&item.oInfo.type=='person'&&item.oInfo.id==id&&!item.oInfo.notInteractive){
               item.oInfo.sos = true;
               this.web3DView.sceneManager.geometryManager.sosObjs.push(item);
               let vector3 = this.web3DView.sceneManager.geometryManager.getMaxYFromModel(item,1);
               this.web3DView.sceneManager.geometryManager.sosSprite(vector3,item.oInfo);
               // this.web3DView.tipsSosSync(item.uuid,item.oInfo.name)
          }
      })
  }
  removeModel(type,id){
      let meshes= this.web3DView.sceneManager.geometryManager.getMeshes();
      meshes.forEach((item,index)=>{
          if(item.oInfo&&item.oInfo.type==type&&item.oInfo.id==id){
               this.web3DView.sceneManager.geometryManager.deleteModel(item);
          }
      })  
  }
  mapTo3d(lon,lat){
     let x = lat-this.web3DView.sceneManager.CoordOffset.lat;
     let z = lon-this.web3DView.sceneManager.CoordOffset.lon;
     let position = new THREE.Vector3(x,0,z);
     let helper = new CARD1Web.CoordUtils.Helper();
     let roadStakes = this.web3DView.sceneManager.geometryManager.getMainRoad().roadModel.model.roadStake;
     let y = helper.getPtHeight(position,roadStakes);
     position.setY(y+60);
     let lookAt = new THREE.Vector3();
     lookAt.copy(position);
     lookAt.setZ(position.z-50);
     this.web3DView.sceneManager.camera.move(position,lookAt);
  }
}


// WEBPACK FOOTER //
// ./src/plugins/js/apis/draw.js